import { useMemo } from 'react';
import Paginate from 'react-paginate';

type PaginationProps = {
	currentPage: number;
	onPageChange: any;
	pageSize: number;
	totalRecords: number;
};

export default function Pagination({
	currentPage,
	onPageChange,
	pageSize,
	totalRecords
}: PaginationProps ) {
	const pageCount = useMemo( () => {
		return Math.ceil( totalRecords / pageSize );
	}, [ pageSize, totalRecords ] );

	const buttonClass = 'w-[35px] h-[35px] flex items-center justify-center text-sm border border-rural-gray-300 rounded-l-sm';
	const selectedClass = 'bg-rural-red-900 text-white';

	return (
		<>
			<Paginate
				activeLinkClassName={ selectedClass }
				containerClassName="flex items-center text-rural-red-900"
				disabledLinkClassName="text-rural-gray-400"
				forcePage={ currentPage }
				nextLabel="&raquo;"
				nextLinkClassName={ buttonClass }
				onPageChange={ onPageChange }
				pageLinkClassName={ `${ buttonClass } border-r-0` }
				pageCount={ pageCount }
				previousLabel="&laquo;"
				previousLinkClassName={ `${ buttonClass } border-r-0` }
				breakClassName={ `${ buttonClass } border-r-0` }
			/>
		</>
	);
}
